import React from 'react'

export const PayPal = ({showPayPal, setShowPayPal, Paypal}) => {
  return (
    <div className="bg-[#F0F0F0] dark:bg-[#282828] p-6 rounded-xl">
        <div className="flex items-center space-x-2">
          <p className="text-2xl">PayPal Email</p>
          <p className={showPayPal ? "dark:bg-[#175220] w-fit px-1 rounded-lg" : "hidden"}>Active</p>
        </div>
        <p className="opacity-60 md:w-3/4">
          Each sale will incur a 25% fee + 2.9% + 30¢ PayPal fee. Your payments
          will be processed in USD. PayPal automatically converts your currency,
          and we'll cover any conversion fees.
        </p>
        <input
          className={showPayPal ? "w-full rounded-lg px-4 py-3 bg-white dark:bg-[#1c1c1c] my-2" : "hidden"}
          type="text"
          placeholder="dorin0007@gmail.com"
        />
        <button onClick={() => setShowPayPal(prev => !prev)} className={showPayPal ? "bg-[#E85959] mt-3 px-4 py-3 rounded-xl " : "hidden"}>
          Disconnect PayPal
        </button>
        <div onClick={() => setShowPayPal(prev => !prev)} className={showPayPal ? "hidden" : "bg-[#1c1c1c] text-white dark:bg-white dark:text-[#1c1c1c] w-fit flex items-center space-x-2 mt-3 px-4 py-3 rounded-xl "}>
          <img src={Paypal} alt="" />
          <p>Connect with PayPal</p>
        </div>
      </div>
  )
}
